// extracted by mini-css-extract-plugin
export default {"tooltipContent":"Tooltip_tooltipContent__yaKNk"};